import { isEqual } from 'lodash';

export function getAddressString(address = {}) {
  const parts = [];
  parts.push(address.address);
  parts.push(address.city);
  parts.push(address.state);
  parts.push(address.zipcode);

  return parts.join(', ');
}

export function getAddressIndex(list, address) {
  for (let i = 0; i < list.length; i++) {
    if (isEqual(list[i], address)) {
      return i;
    }
  }

  return -1;
}

export function getAddressOptions(addresses) {
  return addresses ?
    addresses.map((address, index) => ({
      label: getAddressString(address),
      value: index,
    })) : [];
}
